import aiMl from "../../images/cms_images/ai-ml.webp";

export const cakephpAssets = {
  cakephp: {
    emerging: {
      emerging1: `${process.env.NEXT_PUBLIC_IMAGE_BASE_URL}/assets/images/Cakephp page/emerging/iot.webp`,
      emerging2: aiMl,
      emerging3: `${process.env.NEXT_PUBLIC_IMAGE_BASE_URL}/assets/images/Cakephp page/emerging/ar-vr.webp`,
      emerging4: `${process.env.NEXT_PUBLIC_IMAGE_BASE_URL}/assets/images/Cakephp page/emerging/big-data.webp`,
      emerging5: `${process.env.NEXT_PUBLIC_IMAGE_BASE_URL}/assets/images/Cakephp page/emerging/blockchain.webp`,
      emerging6: `${process.env.NEXT_PUBLIC_IMAGE_BASE_URL}/assets/images/Cakephp page/emerging/cloud-computing.webp`,
    },
    process: {
      process1: `${process.env.NEXT_PUBLIC_IMAGE_BASE_URL}/assets/images/Cakephp page/process/requirement-gathering.webp`,
      process2: `${process.env.NEXT_PUBLIC_IMAGE_BASE_URL}/assets/images/Cakephp page/process/planning.webp`,
      process3: `${process.env.NEXT_PUBLIC_IMAGE_BASE_URL}/assets/images/Cakephp page/process/ux-design.webp`,
      process4: `${process.env.NEXT_PUBLIC_IMAGE_BASE_URL}/assets/images/Cakephp page/process/development.webp`,
      process5: `${process.env.NEXT_PUBLIC_IMAGE_BASE_URL}/assets/images/Cakephp page/process/testing.webp`,
      process6: `${process.env.NEXT_PUBLIC_IMAGE_BASE_URL}/assets/images/Cakephp page/process/deployment.webp`,
    },
    services: {
      service1: `${process.env.NEXT_PUBLIC_IMAGE_BASE_URL}/assets/images/Cakephp page/services/custom-cakephp-development.svg`,
      service2: `${process.env.NEXT_PUBLIC_IMAGE_BASE_URL}/assets/images/Cakephp page/services/cakephp-migration-services.svg`,
      service3: `${process.env.NEXT_PUBLIC_IMAGE_BASE_URL}/assets/images/Cakephp page/services/cakephp-shopping-cart-development.svg`,
      service4: `${process.env.NEXT_PUBLIC_IMAGE_BASE_URL}/assets/images/Cakephp page/services/cakephp-template-design.svg`,
      service5: `${process.env.NEXT_PUBLIC_IMAGE_BASE_URL}/assets/images/Cakephp page/services/cakephp-plugin-module-development.svg`,
      service6: `${process.env.NEXT_PUBLIC_IMAGE_BASE_URL}/assets/images/Cakephp page/services/cakephp-cloud-app-development.svg`,
    },
    whyBenefits: {
      reason1: `${process.env.NEXT_PUBLIC_IMAGE_BASE_URL}/assets/images/Cakephp page/why cakephp -benefits/built-in-security.svg`,
      reason2: `${process.env.NEXT_PUBLIC_IMAGE_BASE_URL}/assets/images/Cakephp page/why cakephp -benefits/reusable-code.svg`,
      reason3: `${process.env.NEXT_PUBLIC_IMAGE_BASE_URL}/assets/images/Cakephp page/why cakephp -benefits/strong-community.svg`,
      reason4: `${process.env.NEXT_PUBLIC_IMAGE_BASE_URL}/assets/images/Cakephp page/why cakephp -benefits/mvc-architecture.svg`,
      reason5: `${process.env.NEXT_PUBLIC_IMAGE_BASE_URL}/assets/images/Cakephp page/why cakephp -benefits/accelerated-development.svg`,
      reason6: `${process.env.NEXT_PUBLIC_IMAGE_BASE_URL}/assets/images/Cakephp page/why cakephp -benefits/object-relational-mapping.svg`,
    },
    whyKonstant: {
      reason1: `${process.env.NEXT_PUBLIC_IMAGE_BASE_URL}/assets/images/Cakephp page/why konstant/rich-domain-experience.svg`,
      reason2: `${process.env.NEXT_PUBLIC_IMAGE_BASE_URL}/assets/images/Cakephp page/why konstant/proven-track-record.svg`,
      reason3: `${process.env.NEXT_PUBLIC_IMAGE_BASE_URL}/assets/images/Cakephp page/why konstant/project-transparency.svg`,
      reason4: `${process.env.NEXT_PUBLIC_IMAGE_BASE_URL}/assets/images/Cakephp page/why konstant/flexible-engagement-model.svg`,
      reason5: `${process.env.NEXT_PUBLIC_IMAGE_BASE_URL}/assets/images/Cakephp page/why konstant/custom-solutions.svg`,
      reason6: `${process.env.NEXT_PUBLIC_IMAGE_BASE_URL}/assets/images/Cakephp page/why konstant/agile-methodology.svg`,
    },
    bg: `${process.env.NEXT_PUBLIC_IMAGE_BASE_URL}/assets/images/cakephp_bg.svg`,
  },
};
